// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/projectdata/v1/go_no_go.proto (package mono.projectdata.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3, Timestamp } from "@bufbuild/protobuf";
/**
 * @generated from message mono.projectdata.v1.GoNoGoEvidenceTask
 */ export class GoNoGoEvidenceTask extends Message {
    static fromBinary(bytes, options) {
        return new GoNoGoEvidenceTask().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GoNoGoEvidenceTask().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GoNoGoEvidenceTask().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GoNoGoEvidenceTask, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string title = 2;
   */ _define_property(this, "title", ""), /**
   * open|in_progress|done|parked
   *
   * @generated from field: string status = 3;
   */ _define_property(this, "status", ""), /**
   * @generated from field: google.protobuf.Timestamp due_at = 4;
   */ _define_property(this, "dueAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GoNoGoEvidenceTask, "runtime", proto3);
_define_property(GoNoGoEvidenceTask, "typeName", "mono.projectdata.v1.GoNoGoEvidenceTask");
_define_property(GoNoGoEvidenceTask, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "due_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GoNoGoEvidenceInteraction
 */ export class GoNoGoEvidenceInteraction extends Message {
    static fromBinary(bytes, options) {
        return new GoNoGoEvidenceInteraction().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GoNoGoEvidenceInteraction().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GoNoGoEvidenceInteraction().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GoNoGoEvidenceInteraction, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: google.protobuf.Timestamp interaction_date = 2;
   */ _define_property(this, "interactionDate", void 0), /**
   * @generated from field: string channel = 3;
   */ _define_property(this, "channel", ""), /**
   * @generated from field: string sentiment = 4;
   */ _define_property(this, "sentiment", ""), /**
   * Blank when the viewer lacks view_sensitive.
   *
   * @generated from field: string summary = 5;
   */ _define_property(this, "summary", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GoNoGoEvidenceInteraction, "runtime", proto3);
_define_property(GoNoGoEvidenceInteraction, "typeName", "mono.projectdata.v1.GoNoGoEvidenceInteraction");
_define_property(GoNoGoEvidenceInteraction, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "interaction_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 3,
            name: "channel",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "sentiment",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "summary",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GoNoGoEvidencePriorRecord
 */ export class GoNoGoEvidencePriorRecord extends Message {
    static fromBinary(bytes, options) {
        return new GoNoGoEvidencePriorRecord().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GoNoGoEvidencePriorRecord().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GoNoGoEvidencePriorRecord().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GoNoGoEvidencePriorRecord, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string outcome = 2;
   */ _define_property(this, "outcome", ""), /**
   * @generated from field: string scope_kind = 3;
   */ _define_property(this, "scopeKind", ""), /**
   * @generated from field: string scope_label = 4;
   */ _define_property(this, "scopeLabel", ""), /**
   * @generated from field: google.protobuf.Timestamp decided_at = 5;
   */ _define_property(this, "decidedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GoNoGoEvidencePriorRecord, "runtime", proto3);
_define_property(GoNoGoEvidencePriorRecord, "typeName", "mono.projectdata.v1.GoNoGoEvidencePriorRecord");
_define_property(GoNoGoEvidencePriorRecord, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "outcome",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "scope_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "scope_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "decided_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GoNoGoEvidenceLegacyDecision
 */ export class GoNoGoEvidenceLegacyDecision extends Message {
    static fromBinary(bytes, options) {
        return new GoNoGoEvidenceLegacyDecision().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GoNoGoEvidenceLegacyDecision().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GoNoGoEvidenceLegacyDecision().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GoNoGoEvidenceLegacyDecision, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * pending|go|defer
   *
   * @generated from field: string outcome = 2;
   */ _define_property(this, "outcome", ""), /**
   * @generated from field: google.protobuf.Timestamp decided_at = 3;
   */ _define_property(this, "decidedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GoNoGoEvidenceLegacyDecision, "runtime", proto3);
_define_property(GoNoGoEvidenceLegacyDecision, "typeName", "mono.projectdata.v1.GoNoGoEvidenceLegacyDecision");
_define_property(GoNoGoEvidenceLegacyDecision, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "outcome",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "decided_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * GoNoGoEvidenceSnapshot is the decision basis as of captured_at. Once stored
 * on a record it is never refreshed.
 *
 * @generated from message mono.projectdata.v1.GoNoGoEvidenceSnapshot
 */ export class GoNoGoEvidenceSnapshot extends Message {
    static fromBinary(bytes, options) {
        return new GoNoGoEvidenceSnapshot().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GoNoGoEvidenceSnapshot().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GoNoGoEvidenceSnapshot().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GoNoGoEvidenceSnapshot, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: google.protobuf.Timestamp captured_at = 1;
   */ _define_property(this, "capturedAt", void 0), /**
   * @generated from field: string pursuit_stage = 2;
   */ _define_property(this, "pursuitStage", ""), /**
   * @generated from field: string solicitation_number = 3;
   */ _define_property(this, "solicitationNumber", ""), /**
   * @generated from field: string customer_agency_names = 4;
   */ _define_property(this, "customerAgencyNames", ""), /**
   * @generated from field: string bid_position = 5;
   */ _define_property(this, "bidPosition", ""), /**
   * @generated from field: string profile_stage_label = 6;
   */ _define_property(this, "profileStageLabel", ""), /**
   * @generated from field: string pwin_percent = 7;
   */ _define_property(this, "pwinPercent", ""), /**
   * Blank when the viewer lacks view_sensitive.
   *
   * @generated from field: string profile_risks = 8;
   */ _define_property(this, "profileRisks", ""), /**
   * @generated from field: repeated mono.projectdata.v1.GoNoGoEvidenceTask tasks = 9;
   */ _define_property(this, "tasks", []), /**
   * tasks not done and not parked
   *
   * @generated from field: int32 unresolved_task_count = 10;
   */ _define_property(this, "unresolvedTaskCount", 0), /**
   * @generated from field: repeated mono.projectdata.v1.GoNoGoEvidenceInteraction interactions = 11;
   */ _define_property(this, "interactions", []), /**
   * @generated from field: repeated mono.projectdata.v1.GoNoGoEvidencePriorRecord prior_records = 12;
   */ _define_property(this, "priorRecords", []), /**
   * @generated from field: repeated mono.projectdata.v1.GoNoGoEvidenceLegacyDecision legacy_decisions = 13;
   */ _define_property(this, "legacyDecisions", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GoNoGoEvidenceSnapshot, "runtime", proto3);
_define_property(GoNoGoEvidenceSnapshot, "typeName", "mono.projectdata.v1.GoNoGoEvidenceSnapshot");
_define_property(GoNoGoEvidenceSnapshot, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "captured_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 2,
            name: "pursuit_stage",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "solicitation_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "customer_agency_names",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "bid_position",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "profile_stage_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "pwin_percent",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "profile_risks",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "tasks",
            kind: "message",
            T: GoNoGoEvidenceTask,
            repeated: true
        },
        {
            no: 10,
            name: "unresolved_task_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 11,
            name: "interactions",
            kind: "message",
            T: GoNoGoEvidenceInteraction,
            repeated: true
        },
        {
            no: 12,
            name: "prior_records",
            kind: "message",
            T: GoNoGoEvidencePriorRecord,
            repeated: true
        },
        {
            no: 13,
            name: "legacy_decisions",
            kind: "message",
            T: GoNoGoEvidenceLegacyDecision,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GoNoGoRecordView
 */ export class GoNoGoRecordView extends Message {
    static fromBinary(bytes, options) {
        return new GoNoGoRecordView().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GoNoGoRecordView().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GoNoGoRecordView().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GoNoGoRecordView, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string capture_project_id = 2;
   */ _define_property(this, "captureProjectId", ""), /**
   * go|no_go|defer
   *
   * @generated from field: string outcome = 3;
   */ _define_property(this, "outcome", ""), /**
   * pursuit|workstream
   *
   * @generated from field: string scope_kind = 4;
   */ _define_property(this, "scopeKind", ""), /**
   * @generated from field: string scope_label = 5;
   */ _define_property(this, "scopeLabel", ""), /**
   * @generated from field: repeated string scope_task_ids = 6;
   */ _define_property(this, "scopeTaskIds", []), /**
   * @generated from field: string rationale = 7;
   */ _define_property(this, "rationale", ""), /**
   * @generated from field: mono.projectdata.v1.GoNoGoEvidenceSnapshot evidence_snapshot = 8;
   */ _define_property(this, "evidenceSnapshot", void 0), /**
   * @generated from field: google.protobuf.Timestamp evidence_captured_at = 9;
   */ _define_property(this, "evidenceCapturedAt", void 0), /**
   * @generated from field: string ai_draft_id = 10;
   */ _define_property(this, "aiDraftId", ""), /**
   * @generated from field: string decided_by = 11;
   */ _define_property(this, "decidedBy", ""), /**
   * @generated from field: google.protobuf.Timestamp decided_at = 12;
   */ _define_property(this, "decidedAt", void 0), /**
   * scope_key is "pursuit" or the sorted scope task ids joined by ",".
   *
   * @generated from field: string scope_key = 13;
   */ _define_property(this, "scopeKey", ""), /**
   * is_current is true for the latest record of its scope_key. A later record
   * for one scope never supersedes another scope's record.
   *
   * @generated from field: bool is_current = 14;
   */ _define_property(this, "isCurrent", false), /**
   * GRW-05: the gate this record decides ("Gate 2"); empty when none.
   *
   * @generated from field: string gate_label = 15;
   */ _define_property(this, "gateLabel", ""), /**
   * GRW-05: the gate review linked to this record (reverse lookup); empty when none.
   *
   * @generated from field: string gate_review_id = 16;
   */ _define_property(this, "gateReviewId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GoNoGoRecordView, "runtime", proto3);
_define_property(GoNoGoRecordView, "typeName", "mono.projectdata.v1.GoNoGoRecordView");
_define_property(GoNoGoRecordView, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "outcome",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "scope_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "scope_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "scope_task_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 7,
            name: "rationale",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "evidence_snapshot",
            kind: "message",
            T: GoNoGoEvidenceSnapshot
        },
        {
            no: 9,
            name: "evidence_captured_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 10,
            name: "ai_draft_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "decided_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "decided_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 13,
            name: "scope_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "is_current",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 15,
            name: "gate_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "gate_review_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GoNoGoAIDraftView
 */ export class GoNoGoAIDraftView extends Message {
    static fromBinary(bytes, options) {
        return new GoNoGoAIDraftView().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GoNoGoAIDraftView().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GoNoGoAIDraftView().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GoNoGoAIDraftView, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string capture_project_id = 2;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string suggested_outcome = 3;
   */ _define_property(this, "suggestedOutcome", ""), /**
   * @generated from field: string suggested_scope_kind = 4;
   */ _define_property(this, "suggestedScopeKind", ""), /**
   * @generated from field: string suggested_scope_label = 5;
   */ _define_property(this, "suggestedScopeLabel", ""), /**
   * @generated from field: repeated string suggested_scope_task_ids = 6;
   */ _define_property(this, "suggestedScopeTaskIds", []), /**
   * @generated from field: string suggested_rationale = 7;
   */ _define_property(this, "suggestedRationale", ""), /**
   * why_lines explains each reason behind the suggestion.
   *
   * @generated from field: repeated string why_lines = 8;
   */ _define_property(this, "whyLines", []), /**
   * if_adopted states what recording this suggestion would (and would not) change.
   *
   * @generated from field: string if_adopted = 9;
   */ _define_property(this, "ifAdopted", ""), /**
   * @generated from field: mono.projectdata.v1.GoNoGoEvidenceSnapshot evidence_snapshot = 10;
   */ _define_property(this, "evidenceSnapshot", void 0), /**
   * model name or "deterministic"
   *
   * @generated from field: string generator = 11;
   */ _define_property(this, "generator", ""), /**
   * draft|accepted|discarded
   *
   * @generated from field: string status = 12;
   */ _define_property(this, "status", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 13;
   */ _define_property(this, "createdAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GoNoGoAIDraftView, "runtime", proto3);
_define_property(GoNoGoAIDraftView, "typeName", "mono.projectdata.v1.GoNoGoAIDraftView");
_define_property(GoNoGoAIDraftView, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "suggested_outcome",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "suggested_scope_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "suggested_scope_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "suggested_scope_task_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 7,
            name: "suggested_rationale",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "why_lines",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 9,
            name: "if_adopted",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "evidence_snapshot",
            kind: "message",
            T: GoNoGoEvidenceSnapshot
        },
        {
            no: 11,
            name: "generator",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "created_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetGoNoGoEvidenceSnapshotRequest
 */ export class GetGoNoGoEvidenceSnapshotRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetGoNoGoEvidenceSnapshotRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetGoNoGoEvidenceSnapshotRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetGoNoGoEvidenceSnapshotRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetGoNoGoEvidenceSnapshotRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetGoNoGoEvidenceSnapshotRequest, "runtime", proto3);
_define_property(GetGoNoGoEvidenceSnapshotRequest, "typeName", "mono.projectdata.v1.GetGoNoGoEvidenceSnapshotRequest");
_define_property(GetGoNoGoEvidenceSnapshotRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetGoNoGoEvidenceSnapshotResponse
 */ export class GetGoNoGoEvidenceSnapshotResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetGoNoGoEvidenceSnapshotResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetGoNoGoEvidenceSnapshotResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetGoNoGoEvidenceSnapshotResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetGoNoGoEvidenceSnapshotResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.GoNoGoEvidenceSnapshot snapshot = 1;
   */ _define_property(this, "snapshot", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetGoNoGoEvidenceSnapshotResponse, "runtime", proto3);
_define_property(GetGoNoGoEvidenceSnapshotResponse, "typeName", "mono.projectdata.v1.GetGoNoGoEvidenceSnapshotResponse");
_define_property(GetGoNoGoEvidenceSnapshotResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "snapshot",
            kind: "message",
            T: GoNoGoEvidenceSnapshot
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.RecordGoNoGoDecisionRequest
 */ export class RecordGoNoGoDecisionRequest extends Message {
    static fromBinary(bytes, options) {
        return new RecordGoNoGoDecisionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RecordGoNoGoDecisionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RecordGoNoGoDecisionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RecordGoNoGoDecisionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", ""), /**
   * go|no_go|defer
   *
   * @generated from field: string outcome = 2;
   */ _define_property(this, "outcome", ""), /**
   * pursuit|workstream
   *
   * @generated from field: string scope_kind = 3;
   */ _define_property(this, "scopeKind", ""), /**
   * @generated from field: string scope_label = 4;
   */ _define_property(this, "scopeLabel", ""), /**
   * Required (non-empty, tasks of this pursuit) for workstream scope; must be
   * empty for pursuit scope. Tasks are referenced, never modified.
   *
   * @generated from field: repeated string scope_task_ids = 5;
   */ _define_property(this, "scopeTaskIds", []), /**
   * @generated from field: string rationale = 6;
   */ _define_property(this, "rationale", ""), /**
   * Optional: the AI draft this human decision was prepared from.
   *
   * @generated from field: string ai_draft_id = 7;
   */ _define_property(this, "aiDraftId", ""), /**
   * GRW-05: free gate label, used only when gate_review_id is empty. Blank = none.
   *
   * @generated from field: string gate_label = 8;
   */ _define_property(this, "gateLabel", ""), /**
   * GRW-05: the due gate review this decision closes (same pursuit, kind
   * 'gate', open, unlinked). Its title becomes the label when gate_label is empty.
   *
   * @generated from field: string gate_review_id = 9;
   */ _define_property(this, "gateReviewId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RecordGoNoGoDecisionRequest, "runtime", proto3);
_define_property(RecordGoNoGoDecisionRequest, "typeName", "mono.projectdata.v1.RecordGoNoGoDecisionRequest");
_define_property(RecordGoNoGoDecisionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "outcome",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "scope_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "scope_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "scope_task_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 6,
            name: "rationale",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "ai_draft_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "gate_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "gate_review_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.RecordGoNoGoDecisionResponse
 */ export class RecordGoNoGoDecisionResponse extends Message {
    static fromBinary(bytes, options) {
        return new RecordGoNoGoDecisionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RecordGoNoGoDecisionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RecordGoNoGoDecisionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RecordGoNoGoDecisionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.GoNoGoRecordView record = 1;
   */ _define_property(this, "record", void 0), /**
   * GRW-05: set when the record saved but marking the gate decided failed.
   *
   * @generated from field: string gate_link_warning = 2;
   */ _define_property(this, "gateLinkWarning", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RecordGoNoGoDecisionResponse, "runtime", proto3);
_define_property(RecordGoNoGoDecisionResponse, "typeName", "mono.projectdata.v1.RecordGoNoGoDecisionResponse");
_define_property(RecordGoNoGoDecisionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "record",
            kind: "message",
            T: GoNoGoRecordView
        },
        {
            no: 2,
            name: "gate_link_warning",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListGoNoGoRecordsRequest
 */ export class ListGoNoGoRecordsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListGoNoGoRecordsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListGoNoGoRecordsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListGoNoGoRecordsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListGoNoGoRecordsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListGoNoGoRecordsRequest, "runtime", proto3);
_define_property(ListGoNoGoRecordsRequest, "typeName", "mono.projectdata.v1.ListGoNoGoRecordsRequest");
_define_property(ListGoNoGoRecordsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListGoNoGoRecordsResponse
 */ export class ListGoNoGoRecordsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListGoNoGoRecordsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListGoNoGoRecordsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListGoNoGoRecordsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListGoNoGoRecordsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.projectdata.v1.GoNoGoRecordView records = 1;
   */ _define_property(this, "records", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListGoNoGoRecordsResponse, "runtime", proto3);
_define_property(ListGoNoGoRecordsResponse, "typeName", "mono.projectdata.v1.ListGoNoGoRecordsResponse");
_define_property(ListGoNoGoRecordsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "records",
            kind: "message",
            T: GoNoGoRecordView,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.DraftGoNoGoWithAIRequest
 */ export class DraftGoNoGoWithAIRequest extends Message {
    static fromBinary(bytes, options) {
        return new DraftGoNoGoWithAIRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DraftGoNoGoWithAIRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DraftGoNoGoWithAIRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DraftGoNoGoWithAIRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", ""), /**
   * pursuit|workstream (default pursuit)
   *
   * @generated from field: string scope_kind = 2;
   */ _define_property(this, "scopeKind", ""), /**
   * @generated from field: string scope_label = 3;
   */ _define_property(this, "scopeLabel", ""), /**
   * @generated from field: repeated string scope_task_ids = 4;
   */ _define_property(this, "scopeTaskIds", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DraftGoNoGoWithAIRequest, "runtime", proto3);
_define_property(DraftGoNoGoWithAIRequest, "typeName", "mono.projectdata.v1.DraftGoNoGoWithAIRequest");
_define_property(DraftGoNoGoWithAIRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "scope_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "scope_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "scope_task_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.DraftGoNoGoWithAIResponse
 */ export class DraftGoNoGoWithAIResponse extends Message {
    static fromBinary(bytes, options) {
        return new DraftGoNoGoWithAIResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DraftGoNoGoWithAIResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DraftGoNoGoWithAIResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DraftGoNoGoWithAIResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.GoNoGoAIDraftView draft = 1;
   */ _define_property(this, "draft", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DraftGoNoGoWithAIResponse, "runtime", proto3);
_define_property(DraftGoNoGoWithAIResponse, "typeName", "mono.projectdata.v1.DraftGoNoGoWithAIResponse");
_define_property(DraftGoNoGoWithAIResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "draft",
            kind: "message",
            T: GoNoGoAIDraftView
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.DiscardGoNoGoAIDraftRequest
 */ export class DiscardGoNoGoAIDraftRequest extends Message {
    static fromBinary(bytes, options) {
        return new DiscardGoNoGoAIDraftRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DiscardGoNoGoAIDraftRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DiscardGoNoGoAIDraftRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DiscardGoNoGoAIDraftRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string draft_id = 2;
   */ _define_property(this, "draftId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DiscardGoNoGoAIDraftRequest, "runtime", proto3);
_define_property(DiscardGoNoGoAIDraftRequest, "typeName", "mono.projectdata.v1.DiscardGoNoGoAIDraftRequest");
_define_property(DiscardGoNoGoAIDraftRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "draft_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.DiscardGoNoGoAIDraftResponse
 */ export class DiscardGoNoGoAIDraftResponse extends Message {
    static fromBinary(bytes, options) {
        return new DiscardGoNoGoAIDraftResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DiscardGoNoGoAIDraftResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DiscardGoNoGoAIDraftResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DiscardGoNoGoAIDraftResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.GoNoGoAIDraftView draft = 1;
   */ _define_property(this, "draft", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DiscardGoNoGoAIDraftResponse, "runtime", proto3);
_define_property(DiscardGoNoGoAIDraftResponse, "typeName", "mono.projectdata.v1.DiscardGoNoGoAIDraftResponse");
_define_property(DiscardGoNoGoAIDraftResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "draft",
            kind: "message",
            T: GoNoGoAIDraftView
        }
    ]));
